// extracted by mini-css-extract-plugin
export var animationContainer = "_nt-0";
export var footer = "_nt-1";
export var gray = "_nt-2";
export var lineItem = "_nt-3";
export var lineItemImage = "_nt-4";
export var lineItemInfo = "_nt-5";
export var lineItemText = "_nt-6";
export var lineItems = "_nt-7";
export var modalContent = "_nt-8";
export var options = "_nt-9";
export var orderName = "_nt-a";
export var refundAmount = "_nt-b";